export default __webpack_public_path__ + "static/media/HelveticaNeue-Bold.160e4e07.otf";